<div
  class="brn-form__option"
  (click)="select()"
  [ngClass]="{ selected: selected }"
>
  <p class="brn-form__option-value">
    {{ label }}
  </p>
</div>
